<div class="company-management-page">
  <div class="company-management-content">
    <div class="company-management-card card">
      <div class="company-management-card-header d-flex flex-wrap justify-content-between align-items-start gap-3">
        <h2 class="company-management-card-title">
          <i class="fa-solid fa-folder-open me-2"></i>
          Programmes
        </h2>

        <div class="company-management-toolbar d-flex flex-wrap justify-content-lg-end gap-2 ms-lg-auto">
          <button
            v-if="role === 'System Admin'"
            class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
            type="button"
            @click="open_support_contact"
          >
            Support Contact
          </button>
          <button class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark" data-bs-toggle="modal" data-bs-target="#create_company">
            Create Programme
          </button>
          <button class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark" data-bs-toggle="modal" data-bs-target="#activate_projects">
            Deactivated Programmes
          </button>
          <button
            class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-white"
            data-bs-toggle="modal"
            data-bs-target="#configure_company_modal"
            aria-label="Configure company"
          >
            <i class='fa-solid fa-gear fs-6 text-white'></i>
          </button>
        </div>
      </div>

      <div class="card-body company-management-card-body">
        <div class="company-programmes-controls row g-3 align-items-center flex-nowrap mb-3">
          <div class="col">
            <input
              v-model="search_query"
              type="text"
              class="form-control form-control-sm text-xxs shadow-sm"
              placeholder="Search programmes..."
              @input="current_page = 1"
            />
          </div>
          <div class="col-auto text-end">
            <span class="company-programmes-count">
              {{ filtered_company_list.length }} programme(s) found
            </span>
          </div>
        </div>

        <div class="company-programmes-table-wrap">
            <table id="main_programs_table" class="table table-hover table-sm align-middle mb-0 programmes-table">
            <colgroup>
              <col class="programme-col">
              <col class="description-col">
              <col class="type-col">
              <col class="date-col">
              <col class="admin-col">
              <col class="actions-col">
            </colgroup>

            <thead class="custom-header">
              <tr>
                <th
                  v-for="h in table_headers"
                  :key="h"
                  class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3"
                  :class="{
                    'programme-column': h === 'Programme',
                    'description-column': h === 'Description',
                    'type-column': h === 'Type',
                    'date-column': h === 'Date Created'
                  }"
                >
                  {{ h }}
                </th>
                <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3 text-nowrap">Actions</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="row in paginated_company_list" :key="'prog-' + row.id ">
                <!-- Program row -->
                <tr class="programme-row">
                  <td
                    v-for="h in table_headers"
                    :key="h"
                    class="text-xxs text-start ps-3"
                    :class="{
                      'fw-semibold': h === 'Programme',
                      'programme-column': h === 'Programme',
                      'description-column': h === 'Description',
                      'admin-column': h === 'Assigned Administrator',
                      'type-column': h === 'Type',
                      'date-column': h === 'Date Created'
                    }"
                  >
                    {{ row[h] }}
                  </td>
                  <td class="text-xxs text-start programme-actions-cell">
                    <div class="programme-actions d-flex flex-wrap gap-1 align-items-center">
                      <button @click="open_company_or_sub_program(row)"
                        class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark programme-action-view">
                        View
                      </button>
                      <button
                        v-if="!row._is_sub_program"
                        class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark programme-action-subprogramme text-nowrap"
                        data-bs-toggle="modal" data-bs-target="#create_sub_program_modal"
                        @click="open_create_sub_program(row.id)">
                        Sub Programme
                      </button>
                      <button
                        v-if="!row._is_sub_program"
                        @click="toggle_program_accordion(row.id)"
                        class="btn btn-primary-dark btn-sm rounded-small text-x shadow text-white programme-action-toggle">
                        <i :class="expanded_programs[row.id] ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down'"></i>
                        
                      </button>
                      <button
                        @click="select_project(row.id)"
                        class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark d-none"
                        data-bs-toggle="modal" data-bs-target="#assign_users">
                        Assign
                      </button>
                      <button
                        v-if="!row._is_sub_program"
                        class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark programme-action-edit"
                        data-bs-toggle="modal" data-bs-target="#update_company"
                        @click="prepopulate_update_company_modal(row.id)">
                        Edit
                      </button>
                      <button
                        v-if="!row._is_sub_program"
                        class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark programme-action-deactivate"
                        @click="deactivate_company(row.id)">
                        Deactivate
                      </button>
                    </div>
                  </td>
                </tr>

                <!-- Sub-programs accordion row -->
                <tr v-if="!row._is_sub_program && expanded_programs[row.id]">
                  <td :colspan="table_headers.length + 1" class="ms-4 p-0 border rounded">
                    <div class="px-4 py-3 border-top border-bottom">
                      <div class="d-flex justify-content-between align-items-center mb-2">
                        <p class="text-xxs text-dark mb-0">
                          Sub Programmes for  : {{ row.Programme }}
                        </p>
                      </div>

                      <!-- Sub-programs list -->
                      <div v-if="sub_programs[row.id] && sub_programs[row.id].length > 0">
                        <div
                          v-for="sp in sub_programs[row.id]" :key="sp.id"
                          class="rounded-lg shadow border mb-2 p-3">
                          <div class="d-flex justify-content-between align-items-center">
                            <div>
                              <p class="text-xs fw-bold mb-0">{{ sp.name }}</p>
                              <p class="text-xxs text-dark mb-0" v-if="sp.description">{{ sp.description }}</p>
                              <small class="text-dark text-xxs">Created : {{ format_date_short(sp.date_created) }}</small>
                            </div>
                            <div class="d-flex gap-1">
                              <button
                                class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
                                @click="redirect_to_sub_program_jobs(sp.id, sp.name, row.id)">
                                View Jobs
                              </button>
                              <button
                                class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
                                data-bs-toggle="modal" data-bs-target="#edit_sub_program_modal"
                                @click="open_edit_sub_program(sp, row.id)">
                                Edit
                              </button>
                              <button
                                class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
                                @click="delete_sub_program(sp.id, row.id)">
                                Deactivate
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Empty state -->
                      <div v-else-if="sub_programs[row.id] && sub_programs[row.id].length === 0"
                        class="text-center py-3">
                        <p class="text-xxs text-dark mb-0">No sub-programmes yet. Click "Create Sub Programme" to add one.</p>
                      </div>

                      <!-- Loading state -->
                      <div v-else class="text-center py-3">
                        <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
                        <p class="text-xxs text-muted mt-1 mb-0">Loading sub-programmes...</p>
                      </div>
                    </div>
                  </td>
                </tr>
              </template>

              <!-- Empty state when no programs -->
              <tr v-if="!filtered_company_list.length">
                <td :colspan="table_headers.length + 1" class="text-center text-muted text-xxs py-4">
                  No programmes found.
                </td>
              </tr>
            </tbody>
            </table>
        </div>

        <CompanyProgrammesResponsiveList
          :rows="paginated_company_list"
          :expanded_programs="expanded_programs"
          :sub_programs="sub_programs"
          :format_date_short="format_date_short"
          @view-programme="open_company_or_sub_program"
          @create-sub-programme="open_create_sub_program"
          @toggle-programme="toggle_program_accordion"
          @edit-programme="prepopulate_update_company_modal"
          @deactivate-programme="deactivate_company"
          @view-sub-programme-jobs="(sub_programme, row) => redirect_to_sub_program_jobs(sub_programme.id, sub_programme.name, row.id)"
          @edit-sub-programme="open_edit_sub_program"
          @deactivate-sub-programme="delete_sub_program"
        />

        <div v-if="total_pages > 1" class="company-programmes-pagination">
          <div class="company-programmes-pagination-summary text-xs text-dark">
            Page {{ current_page }} of {{ total_pages }}
          </div>

          <div class="company-programmes-pagination-controls">
            <button
              class="company-programmes-pagination-button company-programmes-pagination-button--nav"
              type="button"
              @click="current_page = Math.max(current_page - 1, 1)"
              :disabled="current_page === 1"
              aria-label="Previous page"
            >
              <i class="fa-solid fa-chevron-left" aria-hidden="true"></i>
            </button>

            <button
              v-for="page_number in visible_page_numbers"
              :key="page_number"
              class="company-programmes-pagination-button"
              :class="{ 'company-programmes-pagination-button--active': current_page === page_number }"
              type="button"
              @click="current_page = page_number"
            >
              {{ page_number }}
            </button>

            <button
              class="company-programmes-pagination-button company-programmes-pagination-button--nav"
              type="button"
              @click="current_page = Math.min(current_page + 1, total_pages)"
              :disabled="current_page === total_pages"
              aria-label="Next page"
            >
              <i class="fa-solid fa-chevron-right" aria-hidden="true"></i>
            </button>
          </div>

          <div class="company-programmes-pagination-mobile-hint text-xxs text-muted">
            {{ filtered_company_list.length }} total programme(s)
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<SupportContact ref="support_contact" />

<!-- Create Company Modal -->
<teleport to="body">
<div class="modal fade" id="create_company" tabindex="-1" aria-labelledby="create_section_label" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
      <div class="modal-header border-bottom-0 cute-header shadow-lg">
        <p class="modal-title text-white text-xxs" id="create_project_label">
         Create Programme
        </p>
        <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="modal-form-group form-group mb-3">
          <label for="company_name" class="modal-form-label form-label text-xxs">
            Programme Name:
          </label>
          <input type="text" v-model="company_name" class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm"
            placeholder="Enter Client Name Here" />
          <small class="text-danger p-2 text-xxs fw-bold d-none project-name-messages">Please enter a name for the
            Programme</small>
          <small class="text-danger p-2 text-xxs fw-bold d-none error-messages"></small>
        </div>
        <div class="modal-form-group form-group mb-3">
          <label class="modal-form-label form-label text-xxs">Start from an existing programme (optional):</label>
          <select v-model="import_source_project_id" @change="preview_project_configuration" class="modal-form-select form-select text-xxs rounded-small p-2 shadow-sm">
            <option value="">Do not import configuration</option>
            <option v-for="programme in company_list" :key="programme.id" :value="programme.id">{{ programme.name }}</option>
          </select>
          <small class="text-muted text-xxs d-block mt-1">Forms and template documents are copied. They can be assigned when job profiles are created.</small>
        </div>
        <div class="modal-form-group form-group mb-3">
          <label for="company_description" class="modal-form-label form-label text-xxs">
            Programme Description:
          </label>
          <input type="text" v-model="company_description"
            class="modal-form-control form-control text-xs rounded-small p-2 shadow-sm text-xxs"
            placeholder="Enter Client Description Here" />
          <small class="text-danger p-2 text-xxs fw-bold d-none project-description-messages">Please enter a description
            for the Programme</small>
          <small class="text-danger p-2 text-xxs fw-bold d-none error-messages"></small>
        </div>
        <div class="modal-form-group form-group mb-3">
          <label for="company_type" class="modal-form-label form-label text-xxs">
            Programme Type:
          </label>
          <select v-model="selected_company_type" class="modal-form-select form-select text-xxs rounded-small p-2 shadow-sm text-x">
            <option value="" disabled hidden>Select Type</option>
            <option v-for="type in company_types" :key="type.id" :value="type.id">
              {{ type.project_type }}
            </option>
          </select>
          <small class="text-danger p-2 text-xxs fw-bold d-none project-type-messages">Please select a Programme
            type</small>
          <small class="text-danger p-2 text-xxs fw-bold d-none error-messages"></small>
        </div>
      </div>
      <div class="modal-footer border-0 p-2 d-flex justify-content-end">
        <button type="button" class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark" @click="create_company">
          Save
        </button>
      </div>
    </div>
  </div>
</div>
</teleport>

<!-- Assign Users Modal -->
 <teleport to="body">
<div class="modal fade" id="assign_users" tabindex="-1" aria-labelledby="assign_users_label" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
      <div class="modal-header border-bottom-0 cute-header shadow-lg">
        <p class="modal-title text-white text-xxs" id="assign_users_label">Assign Users</p>
        <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <GlobalTable
          v-if="users_list.length > 0"
          :headers="user_table_headers"
          :data="users_list"
          :key="users_list"
          table_id="user_assignment_table"
        >
          <template #actions="{ row }">
            <div class="form-check form-switch">
              <input
                class="form-check-input"
                type="checkbox"
                :id="'switch_' + row.user_id"
                :checked="assigned_users.includes(row.user_id)"
                @change="toggle_assignment(row.user_id)"
              >
              <label class="form-check-label" :for="'switch_' + row.user_id">
                {{ assigned_users.includes(row.user_id) ? 'Assigned' : 'Unassigned' }}
              </label>
            </div>
          </template>
        </GlobalTable>
      </div>
    </div>
  </div>
</div>
</teleport>


<!-- Activate projects Modal -->
 <teleport to="body">
<div class="modal fade" id="activate_projects" tabindex="-1" aria-labelledby="activate_projects_label" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
      <div class="modal-header border-bottom-0 cute-header shadow-lg">
        <p class="modal-title text-white text-xxs" id="activate_projects_label">Activate Programme</p>
        <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
         <div class="card shadow-sm border table-border-color rounded-lg p-3 table-responsive text-xs">
            <table id="deactivated_projects_table" class="table table-hover">
                <thead class="custom-header">
                  <tr>
                    <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">ID</th>
                    <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Client</th>
                    <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Description</th>
                    <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Type</th>
                    <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Assigned Administrator</th>
                    <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="project in deactivated_projects" :key="project.id">
                    <td class="text-xxs text-start">{{ project.id }}</td>
                    <td class="text-xxs text-start">{{ project.name }}</td>
                    <td class="text-xxs text-start">{{ project.project_description }}</td>
                    <td class="text-xxs text-start">{{ project.project_type?.name || '-' }}</td>
                    <td class="text-xxs text-start">{{ project.creator?.full_name || '-' }}</td>
                    <td class="text-xxs text-start">
                      <button class="btn btn-primary-dark btn-sm rounded shadow me-2 text-xxs" @click="activate_projects(project.id)">Activate</button>
                    </td>
                  </tr>
                </tbody>
            </table>
          </div>
      </div>
    </div>
  </div>
</div>
</teleport>


<!-- Update Company Modal -->
 <teleport to="body">
<div class="modal fade" id="update_company" tabindex="-1" aria-labelledby="update_company_label" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
      <div class="modal-header border-bottom-0 cute-header shadow-lg">
        <p class="modal-title text-white text-xxs" id="update_company_label">
         Update Programme
        </p>
        <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">

        <div class="modal-form-group form-group mb-3">
          <label for="update_company_name" class="modal-form-label form-label text-xxs">
            Programme Name:
          </label>
          <input type="text" v-model="update_company_name" class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm" />
          <small class="text-danger p-2 text-xxs fw-bold d-none update-company-name-messages">Please enter a name for the
            Programme</small>
          <small class="text-danger p-2 text-xxs fw-bold d-none error-messages"></small>
        </div>

        <div class="modal-form-group form-group mb-3">
          <label for="update_company_description" class="modal-form-label form-label text-xxs">
            Programme Description:
          </label>
          <input type="text" v-model="update_company_description"
            class="modal-form-control form-control text-xs rounded-small p-2 shadow-sm text-xxs"/>
          <small class="text-danger p-2 text-xxs fw-bold d-none update-company-description-messages">Please enter a description
            for the Programme</small>
          <small class="text-danger p-2 text-xxs fw-bold d-none error-messages"></small>
        </div>

        <div class="modal-form-group form-group mb-3">
          <label for="update_company_type" class="modal-form-label form-label text-xxs">
            Programme Type:
          </label>
          <select v-model="update_selected_company_type" class="modal-form-select form-select text-xxs rounded-small p-2 shadow-sm text-x">
            <option value="" disabled hidden>Select Type</option>
            <option v-for="type in company_types" :key="type.id" :value="type.id">
              {{ type.project_type }}
            </option>
          </select>
          <small class="text-danger p-2 text-xxs fw-bold d-none update-company-type-messages">Please select a Programme
            type</small>
          <small class="text-danger p-2 text-xxs fw-bold d-none error-messages"></small>
        </div>

      </div>
      <div class="modal-footer border-0 p-2 d-flex justify-content-end">
        <button type="button" class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark" @click="update_project">
          Save
        </button>
      </div>
    </div>
  </div>
</div>
</teleport>


<!-- Create Sub Program Modal -->
<teleport to="body">
<div class="modal fade" id="create_sub_program_modal" tabindex="-1" aria-labelledby="create_sub_program_label" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
      <div class="modal-header border-bottom-0 cute-header shadow-lg">
        <p class="modal-title text-white text-xxs" id="create_sub_program_label">Create Sub Programme</p>
        <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="modal-form-group form-group mb-3">
          <label class="modal-form-label form-label text-xxs">Sub Programme Name:</label>
          <input type="text" v-model="create_sp_name"
            class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm"
            placeholder="Enter sub-programme name" />
        </div>
        <div class="modal-form-group form-group mb-3">
          <label class="modal-form-label form-label text-xxs">Description (optional):</label>
          <input type="text" v-model="create_sp_description"
            class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm"
            placeholder="Enter description" />
        </div>
      </div>
      <div class="modal-footer border-0 p-2 d-flex justify-content-end">
        <button type="button" class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark" @click="create_sub_program">
          Save
        </button>
      </div>
    </div>
  </div>
</div>
</teleport>


<!-- Edit Sub Program Modal -->
<teleport to="body">
<div class="modal fade" id="edit_sub_program_modal" tabindex="-1" aria-labelledby="edit_sub_program_label" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
      <div class="modal-header border-bottom-0 cute-header shadow-lg">
        <p class="modal-title text-white text-xxs" id="edit_sub_program_label">Edit Sub Programme</p>
        <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="modal-form-group form-group mb-3">
          <label class="modal-form-label form-label text-xxs">Sub Programme Name:</label>
          <input type="text" v-model="edit_sp_name"
            class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm" />
        </div>
        <div class="modal-form-group form-group mb-3">
          <label class="modal-form-label form-label text-xxs">Description (optional):</label>
          <input type="text" v-model="edit_sp_description"
            class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm" />
        </div>
      </div>
      <div class="modal-footer border-0 p-2 d-flex justify-content-end">
        <button type="button" class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark" @click="save_edit_sub_program">
          Save
        </button>
      </div>
    </div>
  </div>
</div>
</teleport>


<teleport to="body">

<div class="modal fade" id="configure_company_modal" tabindex="-1">

  <div class="modal-dialog modal-dialog-centered modal-lg">

    <div class="modal-content bg-white rounded-3 shadow-lg">

      <div class="modal-header border-bottom-0 cute-header shadow-lg">

        <p class="modal-title text-white text-xxs">
          Select Project For System Configuration
        </p>

        <button
          type="button"
          class="modal-btn-close btn-close"
          @click="close_modal('configure_company_modal')"
          data-bs-dismiss="modal"
          aria-label="Close"></button>

      </div>

      <div class="modal-body">

        <div class="table-responsive">

          <table class="table table-hover">

            <thead class="custom-header">

              <tr>
                <th class="text-uppercase text-xxs ps-3">Project</th>
                <th class="text-uppercase text-xxs ps-3">Configuration</th>
              </tr>

            </thead>

            <tbody>

              <tr v-for="row in config_table_data" :key="row.id">

                <td class="text-xxs ps-3">
                  {{ row.Programme }}
                </td>

                <td class="text-xxs ps-3">

                  <div class="form-check form-switch">

                    <input
                      class="form-check-input"
                      type="checkbox"
                      :id="'config_switch_' + row.id"
                      :checked="isSelectedProject(row.id)"
                      @change="toggle_config_project(row)"
                    >

                    <label
                      class="form-check-label text-xxs ms-2"
                      :for="'config_switch_' + row.id"
                    >
                      {{ isSelectedProject(row.id) ? "Active" : "Select" }}
                    </label>

                  </div>

                </td>

              </tr>

              <tr v-if="config_table_data.length === 0">
                <td colspan="2" class="text-center text-muted text-xxs">
                  No projects available
                </td>
              </tr>

            </tbody>

          </table>

        </div>

      </div>

    </div>

  </div>

</div>

</teleport>

